import { Carousel, Scrollbar } from '../core'

$.fn.Municipalite = function() {
  let self = this
  self.carousel = undefined
  self.scrollbar = undefined

  return function() {
    self.carousel = new Carousel(self.find('.swiper-container').get(0), {
      slidesPerView: 1,
      loop: true,
      pagination: {
        el: self.find('.swiper-pagination').get(0),
        clickable: true,
      },
    })
    self.carousel.init()
    self.scrollbar = new Scrollbar(self.find('.municipality__body'), {
      mobile: false,
    })
    if ($.mlmi.mobile.isMobile) {
      $('.navigator__browser > .navigator__nav--municipality').addClass('will-remove')
      $('.navigator__browser').append(self.find('.navigator__nav--municipality').css('position', 'fixed'))
      $('.navigator__nav .btn-prev').after($('.navigator__btn-close').show())
      $('.navigator__nav--municipality.will-remove').remove()
      if ($.mlmi.municipalitiesNavigator != undefined && $.mlmi.municipalitiesNavigator.navigation != undefined) {
        $.mlmi.municipalitiesNavigator.navigation.registerLinks()
      }
    }
    return self
  }()
}
